// ============================================================================
// O app em francês (09/10/2026): um código só, publicado duas vezes.
//
// `tr('texto em inglês')` devolve o próprio texto no americano e a tradução no
// francês. A chave É o inglês que estava na tela: no americano nada muda por
// construção, e quem lê o componente continua lendo a frase de verdade.
//
// O idioma é decidido no BUILD (`VITE_APP_LOCALE=fr`), não no navegador: são
// duas publicações, cada uma com o seu banco. Sem a variável, é o americano.
//
// Interpolação: `tr('Hi {name}', { name })`. As chaves entre chaves precisam
// existir também na tradução (o teste `i18n-fr.test.ts` confere).
//
// NÃO confundir com `src/lib/translations` + `useTranslation` (en/pt, de 2025,
// quase sem uso): aquilo é outra coisa e fica como está.
// ============================================================================
import { fr } from './fr';

export type AppLocale = 'en' | 'fr';

export const APP_LOCALE: AppLocale = import.meta.env.VITE_APP_LOCALE === 'fr' ? 'fr' : 'en';
export const IS_FR = APP_LOCALE === 'fr';

type Vars = Record<string, string | number>;

function interpolate(text: string, vars?: Vars): string {
  if (!vars) return text;
  return text.replace(/\{(\w+)\}/g, (m, k: string) => (k in vars ? String(vars[k]) : m));
}

const missing = new Set<string>();

export function translate(locale: AppLocale, en: string, vars?: Vars): string {
  if (locale === 'en') return interpolate(en, vars);
  const hit = fr[en];
  if (hit === undefined) {
    // Falta de tradução não pode quebrar a tela: cai no inglês e avisa uma vez.
    if (!missing.has(en)) {
      missing.add(en);
      console.warn('[i18n] sem tradução fr:', en);
    }
    return interpolate(en, vars);
  }
  return interpolate(hit, vars);
}

export function tr(en: string, vars?: Vars): string {
  return translate(APP_LOCALE, en, vars);
}

/** Domínio público desta publicação, para textos que citam o endereço. */
export const APP_HOST = IS_FR ? 'fr.codeofobedience.com' : 'codeofobedience.com';
